import ActivityLogsUserDeveloperPage from "../../../component/users/developers/ActivityLogsUserDeveloper"

 
 
function ActivityLogsUserDeveloper() {
  return (
    <div className="page-body"><ActivityLogsUserDeveloperPage/></div>
  )
}

export default ActivityLogsUserDeveloper